module.exports = __webpack_public_path__ + "media/images/new-ui-images/next-arrow-6e38b2e513c7710158bf28ba32fcdfbf.svg";